import {ApplicationConfig, importProvidersFrom} from '@angular/core';
import {provideRouter} from '@angular/router';

import {routes} from './app.routes';
import {provideAnimationsAsync} from '@angular/platform-browser/animations/async';
import {HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi} from "@angular/common/http";
import {FIREBASE_PROVIDERS} from "./talenlio-hireos/home-layout/common/constant/firebase.providers";
import {CONSTANT} from "./talenlio-hireos/home-layout/common/constant/constant";
import {provideServiceWorker} from "@angular/service-worker";
import {environment as ENVIRONMENT} from "../environments/environment";
import {environment as DEV_ENVIRONMENT} from "../environments/environment.dev";
import {environment as PROD_ENVIRONMENT} from "../environments/environment.prod";
import {LY_THEME, LY_THEME_NAME, LyTheme2} from "@alyle/ui";
import {MinimaLight} from "@alyle/ui/themes/minima";
import {provideLottieOptions} from "ngx-lottie";
import player from 'lottie-web';
import {RequestInterceptor} from './talenlio-hireos/authentication/common/service/auth/request-interceptor';
import {MonacoEditorModule} from "ngx-monaco-editor-v2";

export const appConfig: ApplicationConfig = {
    providers: [
        provideHttpClient(),
        provideRouter(routes),
        provideHttpClient(withInterceptorsFromDi()),
        {
            provide: HTTP_INTERCEPTORS,
            useClass: RequestInterceptor,
            multi: true
        },
        provideAnimationsAsync(),
        FIREBASE_PROVIDERS,
        provideServiceWorker(CONSTANT.SERVICE_WORKER_SCRIPT, {
            enabled: (ENVIRONMENT.name === DEV_ENVIRONMENT.name
                || ENVIRONMENT.name === PROD_ENVIRONMENT.name)
                && !CONSTANT.LOCAL_HOSTNAMES.includes(window.location.hostname),
            registrationStrategy: 'registerWhenStable:30000'
        }),
        provideLottieOptions({
            player: () => player
        }),
        {provide: LY_THEME, useClass: MinimaLight, multi: true},
        {provide: LY_THEME_NAME, useValue: 'minima-light'},
        LyTheme2,
        importProvidersFrom(MonacoEditorModule.forRoot({baseUrl: 'assets/monaco/vs'}))
    ]
};
